const createReadMore = (target, buttonText) => {
   let element = document.createElement("div");
   let elementButton = document.createElement("button");
   elementButton.classList.add("js-read-more");
   elementButton.append(document.createTextNode(buttonText));
   element.classList.add("read-more-toggle");
   element.appendChild(elementButton);
   target.appendChild(element);
   elementButton.addEventListener("click", () => {
      elementButton.parentElement.parentElement.classList.add("is-expanded");
      elementButton.parentElement.remove();
   });
};

const hexToRgb = (hex) => {
   var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
   if (hex === "#fff") return "255, 255, 255";
   return result
      ? `${parseInt(result[1], 16)},${parseInt(result[2], 16)},${parseInt(
           result[3],
           16
        )}`
      : null;
};

const initCreateMores = (targets) => {
   let readMores = [...document.querySelectorAll(targets)];
   readMores.forEach((readMore) => {
      readMore.classList.add("read-more-wrapper");
      const currentBg =
         getComputedStyle(readMore).getPropertyValue("--currentBg");
      readMore.style.setProperty("--currentBg", hexToRgb(currentBg));
      const readMoreText = readMore.dataset.readMoreButtonText
         ? readMore.dataset.readMoreButtonText
         : "Les mer";
      createReadMore(readMore, readMoreText);
   });
};

initCreateMores("[data-read-more]");
